import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ArrowOutwardRoundedIcon from '@mui/icons-material/ArrowOutwardRounded';
import { appSignUp } from '../constants/constants';
import InstallApp from './InstallApp';

export default function IntroCreatePractices() {
  const { t } = useTranslation();
  return (
    <>
    <Box
      sx={{
        minHeight: 'auto',
        display: 'flex',
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'center',
        p: { xs: '160px 16px 0', md: '176px 32px 0' },
        background: 'url(/images/overlay-1.webp) center/cover no-repeat',
        position: 'relative',
        paddingBottom: { xs: 10, md: 20 },
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          zIndex: 1,
        },
      }}
    >
      <Container
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          flexDirection: { xs: 'column', md: 'row' },
          textAlign: { xs: 'center', md: 'left' },
          position: 'relative',
          zIndex: 2,
        }}
      >
        <Box sx={{ flex: 1, minWidth: 300, pt: { xs: 0, md: 4 } }}>
          <Typography
            variant="h1"
            sx={{
              fontFamily: 'Barlow, sans-serif',
              fontSize: { xs: '2.4rem', sm: '3.4rem', md: '3.6rem' },
              fontWeight: 800,
              lineHeight: 1.2,
              mb: 3,
              color: '#1a202c',
            }}
          >
            {t('IntroCreatePractices00')}<br />{t('IntroCreatePractices01')}<br />
            <Box
              component="span"
              sx={{
                background: 'linear-gradient(90deg, #048cec 20%, #fca444 100%)',
                backgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              iCoachBasketball
            </Box>
          </Typography>

          <Typography
            variant="body2"
            sx={{
              fontFamily: 'Barlow, sans-serif',
              fontSize: { xs: '1.15rem', md: '1.3rem' },
              color: '#4a5568',
              mb: 4,
              lineHeight: 1.6,
              maxWidth: 520,
              mx: { xs: 'auto', md: 0 },
              fontWeight: 400,
              letterSpacing: '0.01em',
            }}
          >
            {t('IntroCreatePractices02')}
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2.25,
              alignItems: { xs: 'center', md: 'flex-start' },
            }}
          >
            <Button
              onClick={() => window.location.href = appSignUp}
              endIcon={<ArrowOutwardRoundedIcon />}
              variant="contained"
              sx={{
                background: '#048cec',
                color: 'white',
                px: { xs: 2, md: 3 },
                py: { xs: 1, md: 1.25 },
                fontSize: { xs: '0.8rem', md: '0.85rem' },
                fontWeight: 600,
                borderRadius: '8px',
                textTransform: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: { xs: 0.5, md: 1 },
                whiteSpace: 'nowrap',
                minWidth: 'fit-content',
                height: { xs: '40px', md: '44px' },
                boxShadow: '0 4px 15px rgba(4, 140, 236, 0.2)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 20px rgba(4, 140, 236, 0.3)',
                  background: '#048cec',
                },
                '& .MuiButton-endIcon': {
                  marginLeft: { xs: 0.25, md: 0.5 },
                },
                '& .MuiSvgIcon-root': {
                  fontSize: { xs: 16, md: 18 },
                },
              }}
            >
              {t('IntroCreatePractices03')}
            </Button>
          </Box>
        </Box>

        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            flex: 1,
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <img
            src="/images/hero-multi.png"
            alt="iCoachBasketball multi-device interface"
            style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }}
          />
        </Box>
      </Container>
    </Box>
    <InstallApp />
    </>
  );
};